// extracted by mini-css-extract-plugin
export default {"wrapper":"aD-z","viewport":"bD-z","container":"cD-z","slide":"dD-z"};